<template>
  <el-card class="box-card">
    <div slot="header" class="clearfix">
      <span>产销明细</span>
    </div>

    <el-form ref="queryForm" :model="queryParams" :inline="true">
      <el-form-item label="用户类型" prop="level">
        <el-select
          v-model.number="queryParams.level"
          placeholder="请选择类型"
          clearable
          size="small"
          @keyup.enter.native="handleQuery"
        >
          <el-option
            v-for="(item, index) in userType"
            :key="index"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="奖励类型" prop="type">
        <el-select
          v-model.number="queryParams.type"
          placeholder="请选择类型"
          clearable
          size="small"
          @keyup.enter.native="handleQuery"
        >
          <el-option
            v-for="(item, index) in rewardType"
            :key="index"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="日期" prop="startDate">
        <el-date-picker
          v-model="queryParams.startDate"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item v-if="queryParams.endDate != -1" label="日期" prop="endDate">
        <el-date-picker
          v-model="queryParams.endDate"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="mini" :loading="loading" @click="handleQuery">查询</el-button>
        <el-button v-permisaction="['config:userRemain:export']" :loading="loading" icon="el-icon-download" size="mini" @click="exportData">导出</el-button>
      </el-form-item>
    </el-form>

    <el-card>
      <div slot="header" class="clearfix">
        <span>统计</span>
      </div>
      <el-table
        :data="tableTotal"
        border
        style="width: 100%"
      >
        <el-table-column
          align="center"
          label=""
          prop="type"
        />
        <el-table-column
          prop="grand"
          align="center"
          label="产出"
          :formatter="numFormatter"
        />
        <!--        <el-table-column-->
        <!--          prop="grandAvg"-->
        <!--          align="center"-->
        <!--          label="人均"-->
        <!--        />-->
        <el-table-column
          prop="consume"
          align="center"
          label="消耗"
          :formatter="numFormatter"
        />
        <!--        <el-table-column-->
        <!--          prop="consumeAvg"-->
        <!--          align="center"-->
        <!--          label="人均"-->
        <!--        />-->
        <el-table-column
          prop="balances"
          align="center"
          label="结余"
          :formatter="numFormatter"
        />
        <!--        <el-table-column-->
        <!--          prop="balancesAvg"-->
        <!--          align="center"-->
        <!--          label="人均"-->
        <!--        />-->
      </el-table>
    </el-card>

    <el-card>
      <el-row :gutter="24">
        <el-col :span="12">

          <el-table
            :data="tableGrand"
            border
            style="width: 100%"
          >
            <el-table-column align="center" label="产出">
              <el-table-column
                prop="type"
                align="center"
                label="类型"
              />
              <el-table-column
                prop="num"
                align="center"
                label="总计"
                :formatter="numFormatter"
              />
              <el-table-column
                prop="rate"
                align="center"
                label="占比"
                :formatter="grandFormatter"
              />
            </el-table-column>
          </el-table>

        </el-col>
        <el-col :span="12">

          <el-table
            :data="tableConsume"
            border
            style="width: 100%"
          >
            <el-table-column align="center" label="消耗">
              <el-table-column
                prop="type"
                align="center"
                label="类型"
              />
              <el-table-column
                prop="num"
                align="center"
                label="总计"
                :formatter="numFormatter"
              />
              <el-table-column
                prop="rate"
                align="center"
                label="占比"
                :formatter="consumeFormatter"
              />
            </el-table-column>
          </el-table>

        </el-col>
      </el-row>
    </el-card>
    <el-card>
      <el-row :gutter="24">
        <el-col :span="12">
          <todayEchart ref="grand" :title="'产出'" />
        </el-col>
        <el-col :span="12">
          <todayEchart ref="consume" :color="'#40E0D0'" :title="'消耗'" />
        </el-col>
      </el-row>
    </el-card>
  </el-card>
</template>

<script>
import { getSpinsConsume } from '@/api/statistics/user_remain'
import { getRewardType } from '@/api/config/slot'
import { exportSpinsConsume, getRidTypeList } from '@/api/config/reward-record'
import todayEchart from '@/views/config/spins-consume/compents/today-echart.vue'
import { getCacheQuery, getLastDates, scientificFormat, setCacheQuery } from '@/utils'

export default {
  name: 'Today',
  components: {
    todayEchart
  },
  data() {
    return {
      loading: false,
      tableTotal: [],
      rewardStat: [14, 15, 22],
      // rewardStat: [14, 15, 22, 65, 69, 70],
      grandTotal: 0,
      consumeTotal: 0,
      resourceTotal: {},
      rewardType: [],
      ridType: {},
      tableData: [],
      tableGrand: [],
      tableConsume: [],
      userType: [{ label: '全部', value: 0 }, { label: '非付费用户', value: 1 }, { label: '付费用户', value: 2 }],
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        startDate: '',
        endDate: '-1',
        country: '',
        type: 14,
        level: 0
      }
    }
  },
  created() {
    if (!this.queryParams.startDate) {
      this.queryParams.startDate = getLastDates(1)
    }

    this.getRidTypeData()
    this.getRewardTypeData()
    this.getTables(undefined)
  },
  methods: {
    handleQuery() {
      if (this.queryParams.startDate === '') {
        this.msgError('请选择开始日期')
        return
      }
      this.getTables({})
    },
    getTables(event) {
      this.loading = true
      this.queryParams.endDate = '-1'
      this.queryParams = getCacheQuery(this.$options.name, this.queryParams, event)
      getSpinsConsume(this.queryParams).then(res => {
        this.loading = false
        setCacheQuery(this.$options.name, this.queryParams)
        if (res.code === 200) {
          this.tableGrand = []
          this.tableConsume = []
          this.grandTotal = 0
          this.consumeTotal = 0
          this.tableTotal = []
          if (res.data.rewardStat.length === 0) {
            return
          }
          this.tableData = res.data.data
          if (!this.tableData) {
            this.tableData = []
          }
          if (res.data.data.length <= 0) {
            return
          }
          const resourceTotal = res.data.data[0]
          this.grandTotal = resourceTotal.grant_spin
          this.consumeTotal = resourceTotal.cost_spin
          res.data.rewardStat.forEach(item => {
            if (item.crease === '+') {
              if (this.ridType[item.rid] === undefined) {
                console.log('未知的' + item.rid)
              }
              this.tableGrand.push({
                type: this.ridType[item.rid],
                num: item.num,
                rate: 0
              })
            } else {
              this.tableConsume.push({
                type: this.ridType[item.rid],
                num: item.num,
                rate: 0
              })
            }
          })

          this.tableGrand.forEach((item, index) => {
            const rate = item.num / this.grandTotal * 100
            this.tableGrand[index].rate = rate.toFixed(4)
          })

          this.tableConsume.forEach((item, index) => {
            const rate = item.num / this.consumeTotal * 100
            this.tableConsume[index].rate = rate.toFixed(4)
          })
          this.tableTotal.push({
            type: '总数',
            grand: this.grandTotal,
            consume: this.consumeTotal,
            balances: resourceTotal.stock_spin
          }, {
            type: '人均',
            grand: resourceTotal.grant_spin_avg,
            consume: resourceTotal.cost_spin_avg,
            balances: resourceTotal.stock_spin_avg
          })
          this.$refs.grand.init(this.tableGrand)
          this.$refs.consume.init(this.tableConsume)
          this.queryParams.startDate = res.data.req.endDate
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getRewardTypeData() {
      getRewardType().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            const id = parseInt(i)
            if (this.rewardStat.includes(id)) {
              this.rewardType.push({ 'label': res.data[i], 'value': id })
            }
          }
        }
      })
    },
    getRidTypeData() {
      getRidTypeList().then(res => {
        if (res.code === 200) {
          this.ridType = res.data
          // for (const i in res.data) {
          //   this.ridType.push({ 'label': res.data[i], 'value': parseInt(i) })
          // }
        }
      })
    },
    grandFormatter(row) {
      return row.rate + '%'
    },
    consumeFormatter(row) {
      return row.rate + '%'
    },
    numFormatter(col, row, val) {
      return scientificFormat(val)
    },
    exportData() {
      if (this.queryParams.endDate === -1) {
        this.queryParams.endDate = ''
      }
      if (!this.queryParams.endDate) {
        this.msgError('请选择结束日期')
        return
      }
      this.loading = true
      exportSpinsConsume(this.queryParams).then(item => {
        this.loading = false
        window.open(process.env.VUE_APP_BASE_API + '/' + item.data.path)
      })
    }
  }
}
</script>

<style scoped>

</style>
